import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

export const useRegionColumns = (handleEdit, handleDelete) => {
  const [t] = useTranslation();

  return useMemo(
    () => [
      {
        Header: t("admin.region_name"),
        accessor: "name",
      },
      {
        Header: t("admin.team_limit"),
        accessor: "team_limit",
      },
      {
        Header: t("admin.is_full"),
        accessor: "is_full",
        Cell: ({ value }) => (value ? t("admin.yes") : t("admin.no")),
      },
      {
        Header: t("admin.approved_teams_count"),
        accessor: "approved_teams_count",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: t("admin.draft_teams_count"),
        accessor: "draft_teams_count",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: t("admin.actions"),
        accessor: "uuid",
        Cell: ({ row }) => (
          <div className="flex gap-2">
            <Button
              Icon={PencilSquareIcon}
              onClick={() => handleEdit(row.original)}
              color="primary"
            />
            <Button
              Icon={TrashIcon}
              onClick={() => handleDelete(row.original)}
              color="error"
            />
          </div>
        ),
      },
    ],
    [t, handleEdit, handleDelete]
  );
};
